"use client"

import { useEffect } from "react"
import { FastLink } from "@/components/ui/fast-link"
import { StorefrontRoutesMap } from "@repo/api-shared"

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        // Optionally log to error reporting service
        console.error(error)
    }, [error])

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50">
            <div className="px-6 text-center">
                <div className="mb-4 text-5xl font-bold text-red-600">Ой!</div>
                <h2 className="mb-4 text-2xl font-semibold text-gray-800">
                    Произошла непредвиденная ошибка
                </h2>
                <p className="mx-auto mb-6 max-w-md text-gray-600">
                    Наша команда уже работает над устранением проблемы. Приносим
                    извинения за доставленные неудобства.
                </p>
                <div className="space-x-4">
                    <button
                        onClick={reset}
                        className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-6 py-3 text-base font-medium text-white hover:bg-primary/80 focus:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    >
                        Попробовать снова
                    </button>
                    <FastLink
                        href={StorefrontRoutesMap.HOME}
                        className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-6 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 focus:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2"
                    >
                        На главную
                    </FastLink>
                </div>
            </div>
        </div>
    )
}
